import { render, staticRenderFns } from "./refund-list.vue?vue&type=template&id=5630b90a&scoped=true&"
import script from "./refund-list.vue?vue&type=script&lang=js&"
export * from "./refund-list.vue?vue&type=script&lang=js&"
import style0 from "./refund-list.vue?vue&type=style&index=0&id=5630b90a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630b90a",
  null
  
)

export default component.exports